import { useState } from "react";
import { Link } from "react-router-dom";
import { cookieLocation } from "../../../constants/routing";

const STORAGE_KEY = "cookie_consent";

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

  if (!visible) return null;

  const respond = (value: "accepted" | "declined") => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 animate-in slide-in-from-bottom-4 duration-300">
      <div className="m-4 rounded-2xl border border-white/10 bg-black/85 px-5 py-4 shadow-2xl backdrop-blur-xl sm:mx-auto sm:max-w-2xl sm:px-7 sm:py-5">
        <p className="font-display text-sm font-light leading-relaxed text-white/80">
          We gebruiken cookies om uw ervaring te verbeteren.{" "}
          <Link to={cookieLocation} className="underline underline-offset-4 hover:text-white transition-colors">
            Meer info
          </Link>
        </p>
        <div className="mt-4 flex gap-3">
          <button
            onClick={() => respond("accepted")}
            className="rounded-full bg-accent px-5 py-2 font-display text-sm font-light text-[#1f1a12] transition-colors hover:bg-accent-dark"
          >
            Accepteren
          </button>
          <button
            onClick={() => respond("declined")}
            className="rounded-full border border-white/20 px-5 py-2 font-display text-sm font-light text-white/70 transition-colors hover:border-white/40 hover:text-white"
          >
            Weigeren
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
